/**
 * Returns a key in the format "eventId_marketId".
 *
 * @param {{ event_id: number, market_id: number }} entity
 * An object containing event_id and market_id
 * @returns {string} A string key formatted as "eventId_marketId".
 */
export function generateEventMarketKey(entity = {}) {
    const { event_id: eventId, market_id: marketId } = entity;

    if (!eventId || !marketId) {
        return '';
    }

    return `${eventId}_${marketId}`;
}


/**
 * Generates a sorted array of unique "eventId_marketId" keys
 * from a list of entities.
 *
 * @param {{ event_id: number, market_id: number }[]} entities
 * Array of objects containing event_id and market_id
 * @returns {string[]}
 * Sorted array of unique keys in the format "eventId_marketId"
 */
export function generateEventMarketKeySet(entities) {
  const keys = new Set();

  for (const entity of entities) {
    keys.add(generateEventMarketKey(entity));
  }

  return Array.from(keys).sort();
}


/**
 * Parses an array of "eventId_marketId" strings into structured objects.
 *
 * @param {string[]} betTrackingEventMarketKeys - Array of keys in the format "eventId_marketId"
 * @returns {{ event_id: number, market_id: number }[]}
 * An array of objects containing event_id and market_id
 */
export function parseEventMarketKeys(betTrackingEventMarketKeys) {
  return betTrackingEventMarketKeys.map((key) => {
    const [eventId, marketId] = key.split('_').map(Number);

    return {
      event_id: eventId,
      market_id: marketId,
    };
  });
}
